import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Container, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import Fade from "@material-ui/core/Fade";

import logo from "../../resources/fg-logo.svg";
import "./Header.css";

const useStyles = makeStyles((theme) => ({
  root: {},
  Header: {
    height: "134px",
    marginBottom: "50px",
  },
  Header_logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  Header_nav: {
    display: "flex",
    justifyContent: "space-evenly",
    listStyle: "none",
    "& li": {
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "16px",
      "& a": {
        textDecoration: "none",
        color: "#4F5665",
      },
      "& a:hover": {
        color: "#f53855",
        cursor: "pointer",
      },
    },
  },
  Header_nav_li: {},
  Header_signIn: {
    "& a": {
      textDecoration: "none",
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "16px",
      marginRight: "30px",
      cursor: "pointer",
      marginRight: "20px",
      color: "#0B132A",
    },
  },
  Header_signUp: {
    "& a": {
      textDecoration: "none",
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "16px",
      color: "#f53855",
      outline: "none",
      cursor: "pointer",
    },
    width: "150px",
    height: "45px",
    border: "1px solid #f53855",
    boxSizing: "border-box",
    borderRadius: "50px",
    background: "transparent",
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "16px",
    color: "#f53855",
    outline: "none",
    cursor: "pointer",
  },
  Header_btnDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  Header_mob_nav: {
    display: "none",
    height: "100px",
    // marginBottom: "50px",
    paddingLeft: "2%",
    // background: "green",
  },
  Header_mob_nav_container: {
    position: "absolute",
    height: "100vh",
    width: "100vw",
    top: "0",
    left: "0",
    background: "rgba(255,255,255,0.9)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "9999999",
  },
  Header_mob_nav_hamburger: {
    position: "absolute",
    top: "4%",
    left: "4%",
  },
  Header_mob_nav_close: {
    position: "absolute",
    top: "4%",
    left: "4%",
  },
  a: {
    textDecoration: "none",
  },

  [theme.breakpoints.down("sm")]: {
    Header: {
      display: "none",
    },
    Header_mob_nav: {
      display: "flex",
      zIndex: "99999",
    },
    Header_nav: {
      display: "flex",
      flexDirection: "column",
      listStyle: "none",
      "& li": {
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "normal",
        marginBottom: "20px",
        fontSize: "2.2em",
        "&:hover": {
          color: "#f53855",
          cursor: "pointer",
        },
      },
    },
  },
}));

function Header() {
  const classes = useStyles();

  const [checked, setChecked] = useState(false);
  const [hamburger, sethamburger] = useState(true);
  const handleChange = () => {
    setChecked((prev) => !prev);
    sethamburger((prev) => !prev);
  };

  return (
    <Container>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="center"
        className={classes.Header}
      >
        <Grid item xs={2} md={3} className={classes.Header_logo}>
          <Link to="/">
            <img src={logo} />
          </Link>
        </Grid>

        <Grid item xs={8} md={6}>
          <ul className={classes.Header_nav}>
            <li>
              <NavLink to="/about" activeClassName="nav_Active">
                About
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/how" activeClassName="nav_Active">
                How does it works?
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/pricing" activeClassName="nav_Active">
                Pricing
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/blogs" activeClassName="nav_Active">
                Blogs
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/contact" activeClassName="nav_Active">
                Contact Us
              </NavLink>
            </li>
          </ul>
        </Grid>

        <Grid item xs={2} md={3} className={classes.Header_btnDiv}>
          <span className={classes.Header_signIn}>
            <NavLink exact activeClassName="nav_Active" to="/login">
              Sign In
            </NavLink>
          </span>
          <button className={classes.Header_signUp}>
            <NavLink exact activeClassName="nav_Active" to="/register">
              Sign Up
            </NavLink>
          </button>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        alignItems="center"
        className={classes.Header_mob_nav}
      >
        {hamburger ? (
          <MenuIcon
            className={classes.Header_mob_nav_hamburger}
            onClick={handleChange}
          />
        ) : (
          ""
        )}
      </Grid>
      <Fade in={checked}>
        <Grid className={classes.Header_mob_nav_container}>
          <CloseIcon
            className={classes.Header_mob_nav_close}
            onClick={handleChange}
          />

          <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <ul className={classes.Header_nav}>
              <li>About</li>
              <li>How does it works?</li>
              <li>Pricing</li>
              <li>Blogs</li>
              <li>Contact Us</li>
            </ul>
          </Grid>
        </Grid>
      </Fade>
    </Container>
  );
}

export default Header;
